import React from 'react';
import { Link } from 'react-router-dom';
import { LogOut, Cog, Sparkles, Building2, SlidersHorizontal } from 'lucide-react';

// #81: Optionen-Menü (bündelt Benutzer, Sprache, Administration, Abmelden;
// Glocke und Feedback bleiben bewusst außerhalb). #562: aus Header.js gelöst;
// rendert nur, Zustand und Handler hält der Header. Stile in kopfzeile.css.
// #567: Sprache und „Meine API-Keys“ sind in den Einstellungs-Dialog gezogen.
const OptionenMenue = ({
  t, isMobile, user, userRef, showUserDropdown, setShowUserDropdown,
  setShowReleaseNotes, setShowEinstellungen, customersEnabled, handleLogout, isProjectPlanningMode
}) => (
  <div className="kopf-ankerpunkt" ref={userRef}>
    <button
      onClick={(e) => { e.preventDefault(); setShowUserDropdown(prev => !prev); }}
      title={t('header.options', 'Optionen')} aria-label={t('header.options', 'Optionen')}
      className="kopf-knopf kopf-knopf--hover"
      aria-haspopup="menu"
      aria-expanded={showUserDropdown ? 'true' : 'false'}
    >
      <Cog size={18} />
    </button>
    {showUserDropdown && (
      <div className={`kopf-dropdown kopf-dropdown--optionen${isMobile ? ' kopf-dropdown--mobil' : ''}`}>
        <div className="kopf-abschnitt-kopf">
          <strong className="kopf-einzeilig">{user?.displayName || t('header.user', 'Benutzer')}</strong>
        </div>
        <div className="kopf-optionen-inhalt">
          {/* #567: persönliche Einstellungen (Darstellung, Sprache, API-Keys) */}
          <button
            type="button"
            onClick={() => { setShowUserDropdown(false); setShowEinstellungen(true); }}
            className="kopf-menue-eintrag"
          >
            <SlidersHorizontal size={16} />
            <span>{t('einstellungen.titel', 'Einstellungen')}</span>
          </button>
          {/* #81: Menüpunkte */}
          {/* #85: Changelog/Versions-History auf Abruf */}
          <button
            type="button"
            onClick={() => { setShowUserDropdown(false); setShowReleaseNotes(true); }}
            className="kopf-menue-eintrag"
          >
            <Sparkles size={16} />
            <span>{t('header.whatsNew', 'Was ist neu?')}</span>
          </button>
          {/* #87: Kundenverwaltung für Manager (und Admins) */}
          {customersEnabled && (user?.dbUser?.isManager || user?.dbUser?.isAdmin) && (
            <Link
              to="/customers"
              onClick={() => setShowUserDropdown(false)}
              className="kopf-menue-eintrag"
            >
              <Building2 size={16} />
              <span>{t('header.customers', 'Kundenverwaltung')}</span>
            </Link>
          )}
          {user?.dbUser?.isAdmin && (
            <Link
              to="/admin"
              onClick={() => setShowUserDropdown(false)}
              className="kopf-menue-eintrag"
            >
              <Cog size={16} />
              <span>{t('header.admin', 'Administration')}</span>
            </Link>
          )}
          <button
            onClick={handleLogout}
            className={`btn btn-secondary kopf-abmelden${isProjectPlanningMode ? ' kopf-abmelden--gesperrt' : ''}`}
            disabled={isProjectPlanningMode}
            title={isProjectPlanningMode ? t('header.projectPlanningDisabled', 'Im Vorgangs-Zeitplan deaktiviert') : t('header.logout', 'Abmelden')}
          >
            <LogOut size={16} />
            {t('header.logout', 'Abmelden')}
          </button>
        </div>
      </div>
    )}
  </div>
);

export default OptionenMenue;
